import { render } from "./ApsCalendar.vue?vue&type=template&id=1d91b22f"
import script from "./ApsCalendar.vue?vue&type=script&lang=js"
export * from "./ApsCalendar.vue?vue&type=script&lang=js"

import "./ApsCalendar.vue?vue&type=style&index=0&id=1d91b22f&lang=css"

import exportComponent from "/Users/alejandropascual/Websites/_CODEABLE/Task-181795-Rabbit/wordpress/wp-content/plugins/aps-jackrabbit-calendar/_vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__